"use client";

import { cn } from "@/lib/utils";

import AcademicBuilding from "./academic-building";

/**
 * The /academic-research hero centerpiece: a classical facade whose niches cycle
 * expert faces. The scale wrapper keeps the fixed-pixel illustration crisp while
 * fitting phones; the whole thing is decorative.
 */
export default function AcademicHeroArt({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "relative mx-auto h-[380px] w-full max-w-[460px] md:h-[480px]",
        className,
      )}
      aria-hidden="true"
    >
      <div className="absolute inset-0 flex origin-center scale-[0.6] items-center justify-center sm:scale-[0.76] md:scale-[0.9]">
        <AcademicBuilding />
      </div>
    </div>
  );
}
